import { inject, Injectable } from "@angular/core";
import { JwtToken } from "@shared/models";
import { GlobalService } from "@shared/services";
import { OidcSecurityService } from "angular-auth-oidc-client";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  oidcService = inject(OidcSecurityService);
  globalService = inject(GlobalService);

  init(): void {
    const decodeToken = (token: string): JwtToken | null => {
      try {
        const payload = token.split(".")[1];
        const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );
        const decodedToken = JSON.parse(jsonPayload);
        this.globalService.authedToken.set(decodedToken);
        return decodedToken;
      } catch (error) {
        console.error("Failed to decode JWT", error);
        return null;
      }
    };

    console.log("%cChecking Auth...", "color: lightblue");
    this.oidcService.checkAuth().subscribe((response) => {
      if (!response?.isAuthenticated) {
        this.oidcService.authorize();
      } else {
        decodeToken(response.accessToken);
        console.log(`%cIs authenticated: ${response.isAuthenticated}`, "color: lightgreen");
      }
    });
  }
}
